import Auth from "../utils/auth";

export const validateEntitlement = (
  functionality,
  entitlement,
  accessRights
) => {
  accessRights = accessRights ? accessRights : Auth.get("access");
  let value = false;
  if (
    accessRights !== null &&
    accessRights !== undefined &&
    accessRights.length > 0
  ) {
    for (let i = 0; i < accessRights.length; i++) {
      if (
        accessRights[i].functionality === functionality &&
        accessRights[i].entitlement === entitlement
      ) {
        value = true;
        break;
      }
    }
  }
  return value;
};
